export default "__VITE_ASSET__c40a7520__"